import FormatCurrency from 'components/Common/FormatCurrency'
import LineCreditCardIcon from 'LuxKit/Icons/line/LineCreditCardIcon'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'
import { useAppSelector } from 'hooks/reduxHooks'
import type { ComponentProps } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import NavBarListItem from 'components/NavKit/NavBarListItem'
import NavBarListItemIcon from '../NavBarListItemIcon'

type InheritedListItemProps = Pick<ComponentProps<typeof NavBarListItem>, 'onClick'>

function AccountMenuCreditListItem(props: InheritedListItemProps) {
  const intl = useIntl()
  const balance = useAppSelector(state => state.auth.account.balance)
  const balanceFetched = useAppSelector(state => state.auth.account.balanceFetched)
  const balanceError = useAppSelector(state => state.auth.account.balanceError)

  return <NavBarListItem
    {...props}
    startIcon={<NavBarListItemIcon Icon={LineCreditCardIcon} />}
    title={intl.formatMessage({
      id: 'g9xC1tyKg-nM8LrWiqBN',
      defaultMessage: 'Credits & Payment methods',
    })}
    subtitle={!balanceError && (!balanceFetched || balanceFetched && balance > 0) && <>
      {balance && <FormattedMessage
        id="NLKWud4sPX7n8PwMKA1-"
        defaultMessage="{amount} credits available"
        
        values={{ amount: <FormatCurrency value={balance} /> }}
      />}
      {!balanceFetched && <TextLoadingBox width="6ch" />}
    </>}
    to="/account/credits-payments"
  />
}

export default AccountMenuCreditListItem
